import { render, staticRenderFns } from "./layer-answer-dialog.vue?vue&type=template&id=2f6bcb39&scoped=true&"
import script from "./layer-answer-dialog.vue?vue&type=script&lang=js&"
export * from "./layer-answer-dialog.vue?vue&type=script&lang=js&"
import style0 from "./layer-answer-dialog.vue?vue&type=style&index=0&id=2f6bcb39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6bcb39",
  null
  
)

export default component.exports